import { orderBy, debounce } from 'lodash';

let orderByParams = [['sortOrder', 'createdDate'], ['asc', 'desc']]
let dragTimer;  // for drag handling stuff

export function loadVideos(state, videos) {
    if (videos && videos.length) {
        state.videos.forEach(video => {
            video.createdDate = new Date(video.createdDate).getTime();
        })
        let sortedVideos = orderBy(videos, ...orderByParams);
        state.videos = [...sortedVideos] //.splice(0, 20);
        state.videos.forEach((video, index) => {
            video.sortOrder = index
        })
        state.isLoading = false
    } else {
        state.videos = [];
    }
}

export function loadClips(state, clips) {
    state.clips = clips;
}


export function loadProjects(state, projects) {
    state.projects = projects;
}

export function appendVideos(state, videos) {
    state.videos = [...orderBy([...state.videos, ...videos], ...orderByParams)];
    state.videos.forEach((video, index) => {
        video.sortOrder = index
    })
    state.isLoading = false
}

export function setUserId(state, id) {
    state.userId = id;
}

export function setUrlSlug(state, slug) {
    state.urlSlug = slug;
}

export function setMoreVideos(state, moreVideosState) {
    state.moreVideos = moreVideosState;
}

export function toggleVisible(state, { hardState, video }) {
    if (!hardState) {
        state.videos[video].isVisible = !state.videos[video].isVisible;
    } else {
        state.videos[video].isVisible = hardState.value;
    }
}

export function setDragState(state, dragState) {
    state.dragState = dragState;
}

export function setFilelist(state, files) {
    state.filelist = files;
}

export function handleDragleave(state, e) {
    if (e.dataTransfer.dropEffect === 'none' && e.dataTransfer.effectAllowed !== 'move') {
        debounce(function () {
            dragTimer = setTimeout(() => { state.dragState = false; }, 50)
        }, 350)();
    }
}

export function handleDragover(state, e) {
    if (!e.dataTransfer) {
        e.dataTransfer = {};
        e.dataTransfer.effectAllowed = "move";
        e.dataTransfer.dropEffect = "none";
    }
    setTimeout(() => {
        if ((e.dataTransfer.dropEffect === 'none' && e.dataTransfer.effectAllowed !== 'move') || (e.dataTransfer.dropEffect === 'move' && e.dataTransfer.effectAllowed === 'uninitialized')) {
            clearTimeout(dragTimer);
            !state.dragState ? state.dragState = true : null;
        }
    }, 100);
}

export function handleDragenter(state, e) {
    if (e.dataTransfer.dropEffect === 'none' && e.dataTransfer.effectAllowed !== 'move') {
        debounce(function () {
            state.dragState = true;
        }, 300)();
    }
}

export function addVideoToList(state, video) {
    if (state.videos.length >= 3) {
        let vid0 = state.videos.shift();
        let vid1 = state.videos.shift();
        state.videos.unshift(vid1);
        state.videos.unshift(vid0);
        state.videos.unshift(video);
    } else if (state.videos.length === 2) {
        let vid0 = state.videos.shift();
        state.videos.unshift(vid0);
        state.videos.unshift(video);
    } else if (state.videos.length < 2) {
        state.videos.unshift(video);
    }
}

export function updateList(state, videos) {
    state.videos = [...orderBy(videos, ...orderByParams)];
}

export function setVideoSortOrder(state) {
    for (let i = 0; i < state.videos.length; i++) {
        state.videos[i].sortOrder = i;
    }
    state.oldVideos = state.videos  // remove observer stuff
}

export function toggleState(state, { prop, toggleState }) {
    state[prop] = toggleState;
}

export function saveEditDetails(state, { id, name, description, isHighlightReel }) {
    let videoId = state.videos.findIndex(video => video.id == id);
    state.videos[videoId].name = name;
    state.videos[videoId].description = description;
    state.videos[videoId].isHighlightReel = isHighlightReel;
}

export function swapVideos(state, id) {
    state.videos.forEach((vid, i) => {
        if (vid.id === id) {
            let [newVid] = state.videos.splice(i, 1);
            state.videos.unshift(newVid);
        }
    });
}

export function setActiveTab(state, tab) {
    state.activeTab = tab;
}

export function setFeaturedVideo(state) {
    state.featuredVideo = state.videos.filter(video => video.isFeatured)[0] || { isEmpty: true }
}

export function checkMobile(state) {
    state.isMobile = window.innerWidth <= 640;
}

export function changeFeatured(state, video) {
    state.videos.forEach(vid => vid.isFeatured = false);
    state.featuredVideo = video;
    state.videos.forEach(vid => {
        if (vid.id === video.id) {
            vid.isFeatured = true;
        }
    }
    )
}

export function clearFeatured(state) {
    state.videos.forEach(video => {
        if (video.id === state.featuredVideo.id) {
            video.isFeatured = false;
        }
    })
    state.featuredVideo = { isEmpty: true }
}

export function setVideoPlaylistIsLoaded(state, payload) {
    state.videoPlaylist.isLoaded = payload;
}

export function setVideoPlaylistUrl(state, payload) {
    state.videoPlaylist.url = payload;
}

export function setVideoPlaylistId(state, payload) {
    state.videoPlaylist.id = payload;
}

export function setHasUploadedVideo(state, payload) {
    state.hasUploadedVideo = payload
}

export function setHasVideoPlaylists(state, payload) {
    state.hasVideoPlaylists = payload
}

export function setVideoPlaylistName(state, payload) {
    state.videoPlaylist.name = payload;
}

export function setVideoPlaylistPublishedAt(state, payload) {
    state.videoPlaylist.publishedAt = payload;
}

export function setVideoPlaylistCreatedAt(state, payload) {
    state.videoPlaylist.createdAt = payload;
}